import { AlignSelfType } from 'common/types/styleTypes'
import styled from 'styled-components'

interface SuccessButtonTextUiProps {
  alignSelf?: AlignSelfType
  mobileAlignSelf?: AlignSelfType
  textColor?: string
}
export const SuccessButtonTextUi = styled.p<SuccessButtonTextUiProps>`
  align-self: ${p => p.alignSelf || 'center'};
  margin-top: 10px;
  ${p => p.textColor && `color: ${p.textColor};`}
  ${p => `
      ${p.theme.phone} {
    align-self: ${p.mobileAlignSelf || 'center'};
  }
`}
`
